<h1>Funds Movements</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs | visibleFinanceTabs; track tab) {
    <a mat-tab-link (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
      {{tab.title}}
    </a>
  }
</nav>

<div class="actionwrapper">
  <div class="actions">
    <button mat-raised-button color="primary" (click)="reloadAll()">Refresh</button>
    <button mat-raised-button color="primary" (click)="addItem()">
      <mat-icon>add</mat-icon>
      Ingest Movement
    </button>
  </div>
</div>

<div class="movement-toolbar">
  <mat-form-field appearance="fill">
    <mat-label>Search funds movements</mat-label>
    <input
      matInput
      [(ngModel)]="movementSearchFilter"
      (ngModelChange)="onMovementSearchChange()"
      placeholder="ID, contract, provider, type, status...">
    @if (movementSearchFilter) {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear funds movement search"
        (click)="clearMovementFilter()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <span class="movement-count">
    {{movementsLoaded | number}} results loaded
    @if (movementsLoading) {
      <span>…</span>
    }
  </span>
</div>

<div class="movement-table-container" (scroll)="onMovementScroll($event)">
  <table class="table" mat-table matSort [dataSource]="items">
    <ng-container matColumnDef="contractId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.contractId}}</td>
    </ng-container>

    <ng-container matColumnDef="provider">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.provider}}</td>
    </ng-container>

    <ng-container matColumnDef="movementType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Movement Type</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.movementType}}</td>
    </ng-container>

    <ng-container matColumnDef="direction">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Direction</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.direction}}</td>
    </ng-container>

    <ng-container matColumnDef="grossAmount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Gross Amount</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.grossAmount}}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
      <td class="cell" mat-cell *matCellDef="let item">{{getCreatedAt(item) | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.status}}</td>
    </ng-container>

    <ng-container matColumnDef="ledgerTransactionId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ledger Tx ID</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.ledgerTransactionId || '-'}}</td>
    </ng-container>

    <ng-container matColumnDef="actionmenu">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td class="cell" mat-cell *matCellDef="let item">
        <button mat-icon-button [matMenuTriggerFor]="movementMenu" aria-label="Movement actions">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #movementMenu="matMenu">
          <button mat-menu-item (click)="openFundsMovementDetails(item)">
            <mat-icon>visibility</mat-icon>
            <span>Details</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
  </table>
</div>

<div class="unmapped-panel">
  <h3>Unmapped Provider Events</h3>
  <div class="unmapped-filters">
    <mat-form-field appearance="fill">
      <mat-label>Provider</mat-label>
      <mat-select [(ngModel)]="unmappedProviderFilter" (selectionChange)="applyUnmappedFilters()">
        <mat-option value="ALL">All</mat-option>
        <mat-option value="STRIPE">Stripe</mat-option>
        <mat-option value="DWOLLA">Dwolla</mat-option>
        <mat-option value="MANUAL">Manual</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>From Date</mat-label>
      <input matInput type="date" [(ngModel)]="unmappedFromDate" (ngModelChange)="applyUnmappedFilters()">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>To Date</mat-label>
      <input matInput type="date" [(ngModel)]="unmappedToDate" (ngModelChange)="applyUnmappedFilters()">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Search</mat-label>
      <input matInput [(ngModel)]="unmappedSearchFilter" (ngModelChange)="applyUnmappedFilters()" placeholder="ID, type, direction, status...">
    </mat-form-field>

    <button mat-stroked-button (click)="clearUnmappedFilters()">Clear Filters</button>
  </div>
  <table class="table" mat-table [dataSource]="unmappedItems">
    <ng-container matColumnDef="provider">
      <th mat-header-cell *matHeaderCellDef>Provider</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.provider}}</td>
    </ng-container>

    <ng-container matColumnDef="movementType">
      <th mat-header-cell *matHeaderCellDef>Movement Type</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.movementType}}</td>
    </ng-container>

    <ng-container matColumnDef="direction">
      <th mat-header-cell *matHeaderCellDef>Direction</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.direction}}</td>
    </ng-container>

    <ng-container matColumnDef="grossAmount">
      <th mat-header-cell *matHeaderCellDef>Gross Amount</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.grossAmount}}</td>
    </ng-container>

    <ng-container matColumnDef="occurredAt">
      <th mat-header-cell *matHeaderCellDef>Occurred At</th>
      <td class="cell" mat-cell *matCellDef="let item">{{item.occurredAt | date:'medium'}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td class="cell" mat-cell *matCellDef="let item">
        {{item.status}}
        @if (getClassificationState(item)) {
          <span> / {{getClassificationState(item)}}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="actionmenu">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td class="cell" mat-cell *matCellDef="let item">
        <button mat-stroked-button color="primary" (click)="reclassifyUnmapped(item)">
          Reclassify
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="unmappedColumnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: unmappedColumnNames"></tr>
  </table>
</div>

<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
